<template>
  <div>
    <div class="cookie_div" id="cookie_wrapper">
      <div class="cookie_container">
        <div class="cookie_subcontainer">
        <div class="cookies_card">
                <div class="cookie_info">
                <h4 class="cookie_title">Herzlich willkommen</h4>
                <p >Diese Website verwendet Cookies um Ihnen ein besseren Besuch unserer Homepage zu ermöglichen. Einige von  diesen sind zur Nutzung der Website essentiell, während andere Cookies uns dabei helfen bspw. Störungen zu erkennen oder das Nutzerverhalten auf unserer Seite zu analysieren und zu verbessern.</p>
                <p>Detaillierte Informationen zu den Cookies finden Sie unter <a class="cookie_datenschutz" href="https://www.invers-gruppe.de/datenschutz.php" target="_blank">Datenschutz. </a>
                </p>
                <input type="checkbox" id="Notwendig" name="Notwendig" value="Notwendig" checked disabled>
                <label for="vehicle1">Notwendig</label>
                <input type="checkbox" class="analytisch" id="analytisch" name="analytisch" value="analytisch">
                <label for="vehicle1">Analytisch</label>
                </div>
                <div class="coo_btn"> 
                  <button class="cookie_btn_Ablehnen"  id="cookie_btn_Ablehnen_t" @click="cookie_Ablehnen_t">Optionale Cookies ablehnen</button>
                  <button class="cookie_btn" id="cookie_btn_Zulassen" @click="cookie_Zulassen">Alle zulassen</button>
                </div>   
              </div>
          </div>
        </div>
    </div>
    <div fluid class="teamFilter">
      <v-container>
        <v-row justify="center">
          <v-col
           id="filterselect"
            cols="12"
            sm="10"
            md="7"
            class="marginAbstandCol d-flex"
          >
            <v-select
              @change="getItems(vselect)"
              v-model="vselect"
              :items="dropdownItems"
              label="Abteilung aussuchen"
              class="fontSize"
              :menu-props="{ contentClass: 'paddingAbstand'}">
            >
            </v-select>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <div fluid class="MitarbeitenContainer">
      <v-container>
        <v-row justify="center">
          <v-col
            cols="12"
            sm="5"
            md="4"
            lg="3"
            class="addedValuesItemsWrapper"
            v-for="(item, i) in tempItems"
            :key="i"
          >
            <div class="addedValuesItem" v-show="item.abteilung">
              <v-img
                class="vImg"
                height="200px" 
                contain
                :src="item.src"
                :alt="item.alt"
                aspect-ratio="1"
              >
                  <template v-slot:placeholder>
                    <v-layout
                      fill-height
                      align-center
                      justify-center
                      ma-0
                    >
                      <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                    </v-layout>
                  </template>
              </v-img>
              <!-- <img :src="item.src" :alt="item.alt"> -->
              <h5 v-text="item.name" class="vImgName"></h5>
              <!-- <p v-text="item.title"></p> -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>

import dbItems from './db.json';

export default {

  data: () => ({
    vselect: 'Alle',
    tempItems: [],
    items: dbItems.todos,
    dropdownItems: ['Alle', 'Bereichsleitung', 'Bestandsübertragung','Datenerfassung und –verarbeitung','Direktkundenbetreuung', 'Finanzen','Geschäftsführung','Gewerbe','Investment','IT','Kfz','Kranken','Leben','Maklerbetreuung','Medien & Kommunikation','SHU','mehr'],
  }),
  created() {
    // eslint-disable-next-line vue/return-in-computed-property

    // eslint-disable-next-line vue/no-side-effects-in-computed-properties
    // Cornelia Fentzahn , Mathias Weber sind 2 mal
    for (let i = 0; i < this.items.length; i++) {

      if (i === 2 ) { continue; } //das ist 2. Alex, soll nicht zeigen 
      if (i === 16 ) { continue; } //das ist 2. Cornelia Fentzahn, soll nicht zeigen
      if (i === 52 ) { continue; } //das ist 2. Mathias Weber, soll nicht zeigen
      if (i === 54 ) { continue; } //das ist 2. Matthias Scholz, soll nicht zeigen (Matthias Scholz hat id 44 aber, er ist 45.objekt. von 0 anfangen)
     
      this.tempItems.push(this.items[i]);
    }
   
  },
  mounted(){
    const cookiename = document.cookie;
    if(!cookiename.includes("cookie=true")){
      console.log(!cookiename.includes("cookie=true"));
      document.getElementById("cookie_wrapper").style.display = "block";
    }
   
  },
  methods: {
    

    
    cookie_Ablehnen: function (){
        document.getElementById("cookie_wrapper").style.display = "none";
    },
    setCookie : function(cName, cValue, expDays)  {
        let date = new Date();
        console.log(date);
        date.setTime(date.getTime() + (expDays * 48 * 60 * 60 * 1000));
        const expires = "expires=" + date.toUTCString();
        document.cookie = cName + "=" + cValue + ";" + expires + "; path=/"; //"; path=/,path=/about"  ,path=/invers.php,path=/support.php,path=/support.php,path=/betreuung.php,path=/team/,path=/jobs/,path=/kontakt.php,path=/login.html
    },

    getCookie : function(cName)  {
        const name = cName + "=";
        const cDecoded = decodeURIComponent(document.cookie);
        const cArr = cDecoded.split("; ");
        let value;
        cArr.forEach(val => {
        if(val.indexOf(name) === 0)
            value = val.substring(name.length);
        
        })
        console.log(value);
        return value;
    },

        // When user clicks the accept button
    cookie_Zulassen: function (){

        console.log("hello world")
        this.setCookie("cookie", true, 1)

        //Hide the popup
        document.getElementById("cookie_wrapper").style.display = "none";
    },

                // When user clicks the Ablehnen button
    cookie_Ablehnen_t: function (){
                
        console.log("hello world")
        this.setCookie("cookie", true, 1)

        //Hide the popup
        document.getElementById("cookie_wrapper").style.display = "none";
    },

    cookieMessage : () => {
        if(!this.getCookie("cookie")){
        console.log(this.getCookie("cookie"));
        document.getElementById("cookie_wrapper").style.display = "block";
        }
        
    },

    getItems: function (abteilung) {
      if(abteilung === "Alle") {
        this.getallItems();
        return
      }
      (this.tempItems = []),
        this.items.forEach((e) => {
          if (e.abteilung === abteilung) {
            this.tempItems.push(e);
          }
        });
    },
    getallItems: function () {
      (this.tempItems = []),

        this.items.forEach((e) => {
          if (e.id < 84 ) { //zumBeispiel : e.id < 76, weil nur bis 75, weil >76 Doubble sind
            console.log(e.id)
            this.tempItems.push(e);
           }
        });
    },
  },
};
</script>
<style scoped>
.MitarbeitenContainer {
  background-color: rgb(238, 239, 239);
  padding: 30px 0 50px 0;
  color: #000;
  z-index: 1;
  position: relative;
}
.fontSize{
  font-weight:400;
}
.marginAbstandCol{
  margin: 40px 0;
}
.marginAbstand{
  margin:8px;
}
.addedValuesItemsWrapper {
  margin-top: 50px;
}
.addedValuesItem {
  background-color: #fff;
  height: 280px;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
}
.addedValuesItem h5 {
  font-size: 17px;
}
.addedValuesItem img {
  width: 220px;
  margin-bottom: 20px;
}
.vImg {
  display: block;
  margin-left: auto;
  margin-right: auto;

}

.show {
  display: block;
}

.Lebensversicherung {
  display: none;
}
@media(min-width: 768px) {
  .fontSize{
    font-size: 25px;
    font-weight:450;
  }
  #filterselect{
    line-height: 25px !important;
  }
  .fontSize>>>.v-select__selection{
    padding:10px !important;
  }

}
@media(min-width: 576px) {
  .vImgName{
  margin-top:15px;
  }
}
@media(max-width: 768px) {
  .marginAbstand{
    margin:4px;
  }
}
@media(max-width: 576px) {
  .marginAbstand{
    margin:2px;
  }
}
@media(max-width: 400px) {
  .marginAbstand{
    margin:0px;
  }
}

/* cookie */
.cookie_container{
	width:1600px;
	margin:auto;
}
.cookie_subcontainer{
	width:85%;
	margin:auto;
}
.cookie_div{
	width: 100%;
	position:fixed;
	bottom:0;
	color:#fff;
	background-color:rgba(0, 0, 0, 0.6);
	z-index:20001;
	display:none;
}
.cookies_card{
	min-height:230px;
	display:flex;
	justify-content:space-between;
	align-items:center;
	flex-wrap:wrap;
	gap:10px;
}

.cookie_title{
  margin-top: 10px;
	padding:5px 0; 
	color:#ef771e;
}
.cookie_datenschutz{
	color:#ef771e;
	border-bottom:dotted #ef771e;
	text-decoration: none;
}
.cookie_datenschutz:hover{
	color:#ef771e;
	border-bottom:dotted #ef771e;
	text-decoration: none;
}
.cookie_info{
	text-align: justify;
}

.analytisch{
	background-color:#ef771e !important;
	color:#ef771e !important;
}
.coo_btn{
	margin-bottom:30px;
}
.cookie_btn{
		color:#fff; 
		border:none;
		background-color:#ef771e;
		border-color: #ef771e;
		border-radius: 4px;
		
		padding: 5px 12px;
		margin:5px;
		font-size: 14px;

}
.cookie_btn:hover,
.cookie_btn:focus,
.cookie_btn:active,
.cookie_btn:visited{
		border-color: #ef771e;
		border:none;
		box-shadow: -3px 2px 18px -4px rgb(0 0 0 / 69%) !important;
		transform: scale(1.1);
	}

	.cookie_btn_Ablehnen{
		color:#000; 
		border:none;
		background-color:rgb(238, 239, 239);
		border-color: rgb(238, 239, 239);
		border-radius: 4px;
		padding: 5px 12px;;
		margin:5px;
		font-size: 14px;

	}
	.cookie_btn_Ablehnen:hover,
	.cookie_btn_Ablehnen:focus,
	.cookie_btn_Ablehnen:active,
	.cookie_btn_Ablehnen:visited{
		border-color: rgb(238, 239, 239);
		border:none;
		box-shadow: -3px 2px 18px -4px rgb(0 0 0 / 69%) !important;
		transform: scale(1.1);
	}

@media(max-width:1600px){
	.cookie_container{
		width:100%;
	}
}
@media(max-width:1024px){
	.cookies_card{
		padding:20px ;
	}
}
/***************/
</style>
